<!--component html goes here -->
<div class="d-flex justify-content-center flex-column">
  <div class="tabs">
    <a *ngFor="let tab of tabs; let idx = index" class="" role="button" [ngClass]="{ 'active': isActiveTab(idx) }"
      (click)="setActiveTab(idx)"><span>{{tab}}</span></a>
  </div>